<template>
    <div class="">
        <PopupWindow v-if="isVisiblePopup" :key="modal" :header="modal.header" :info="modal.info"
            :buttonText="modal.button" :color="modal.color"></PopupWindow>

        <div>
            <TabsComponent :tabs="pageTabs" @tab-active="updateActiveTab">
                <div v-if="activeTab === 'offer'">
                    <div class="our_s">
                        <p class="base_18 gray">Медицинское такси для пациентов и всех тех, кому требуется
                            услуга по перевозке больных,
                            это еще и удовлетворение уникальных транспортных потребностей медицинского учреждения. </p>
                        <p class="base_18 gray">Сервис Medmobil, содействуя точечному развитию
                            здравоохранения, привлекает опытных
                            поставщиков медицинских транспортных услуг для помощи всем, кто в них нуждается. </p>
                        <p class="base_18 gray">Общими усилиями мы можем способствовать улучшению качества
                            оказания медицинской помощи
                            пациентам, удаленным от медицинских учреждений, а также облегчить жизнь тем, кто физически
                            не способен добраться
                            до медицинских услуг самостоятельно.</p>
                        <p class="base_18 gray">
                            <span class="base_18 gray">Зарегистрировавшись в сервисе Medmobil, вы получите
                                возможность:</span>
                        <ul class="base_18 gray" style="list-style-type: disc; padding-left: 40px;">
                            <li>
                                <p class="base_18 gray">круглосуточно получать неограниченное количество
                                    заявок на перевозку в соответствии с перечнем Ваших услуг;</p>
                            </li>
                            <li>
                                <p class="base_18 gray">общаться с клиентом напрямую после принятия заказа;
                                </p>
                            </li>
                            <li>
                                <p class="base_18 gray">указать все виды Вашего транспорта, которые
                                    используете для перевозки;</p>
                            </li>
                            <li>
                                <p class="base_18 gray">определить локации, в пределах которых Вы
                                    оказываете услуги;</p>
                            </li>
                            <li>
                                <p class="base_18 gray">управлять любым количеством заявок;</p>
                            </li>
                            <li>
                                <p class="base_18 gray">хранить историю оказанных услуг и получать
                                    статистическую информацию о Ваших перевозках.</p>
                            </li>
                        </ul>
                        </p>
                        <p class="base_18 gray">Внимание сервиса Medmobil не акцентировано только на
                            определенных перевозчиках или
                            медицинских учреждениях, мы рады сотрудничеству с организациями разных форм собственности.
                        </p>
                    </div>

                    <div class="rules">
                        <p class="base_18 gray">Приглашаем Вас к совместной продуктивной работе.
                            Присоединяйтесь к нашей большой команде, чтобы помочь людям на пути к здоровью! </p>
                        <p class="base_18 gray">Пожалуйста, заполните и отправьте заявку. После ее
                            рассмотрения на указанную Вами электронную почту придет письмо. Далее Вы сможете подтвердить
                            Вашу регистрацию в сервисе и получите возможность работать с заказчиками. </p>
                    </div>
                </div>

                <div v-if="activeTab === 'user'">
                    <FormComponent formName="CarriersForm" @response="handleFormResponse"
                        @inputErrors="updateFormErrors" :action="sendResponseCarriers"
                        class="row g-4 authentication-page__auth">
                        <template v-slot="{ handleInputError, checkInputError }">

                            <div>
                                <p class="base_18 gray">Приглашаем Вас к совместной продуктивной работе.
                                    Присоединяйтесь к нашей большой команде, чтобы помочь людям на пути к здоровью! </p>
                                <p class="base_18 gray">Пожалуйста, заполните и отправьте заявку. После ее
                                    рассмотрения на указанную Вами электронную почту придет письмо. Далее Вы сможете
                                    подтвердить Вашу регистрацию в сервисе и получите возможность работать с
                                    заказчиками. </p>
                                <label>
                                    <p class="marginPaddingForm" style="text-align: left;padding-top:0vw;"><b
                                            class="formlabel">Ваша заявка на участие в сервисе Medmobil</b></p>
                                </label>
                            </div>

                            <div>
                                <div class="row g-4">
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="reg_name" @error="handleInputError" ref="firstname"
                                            id="firstname" name="firstname" label="Имя" required />
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="reg_secondname" @error="handleInputError" ref="secondname"
                                            id="secondname" name="secondname" label="Отчество" />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="row g-4">
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="reg_email" @error="handleInputError"
                                            :validationFunction="tools.validateEmail" ref="email" id="email"
                                            name="email" label="Электронная почта" required />
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="phone" @input="onlyNumbers" @error="handleInputError"
                                            :validationFunction="tools.validatePhone" :mask="tools.formatPhone"
                                            ref="phone" id="phone" name="phone" label="Номер телефона"
                                            placeholder="+7 (___) ___-__-__" required />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="row g-4">
                                    <div class="col-12 col-lg-8">
                                        <CInput v-model="reg_organisation" @error="handleInputError" ref="organisation"
                                            id="organisation" name="organisation"
                                            label="Наименование организации или ИП" required />
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <CInput v-model="inn" :mask="tools.formatNumber(999999999999)"
                                            class="forminput inn_input" @error="handleInputError" maxlength="12"
                                            ref="inn" id="inn" name="inn" label="ИНН" placeholder="____________"
                                            required />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div class="row g-4">
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="reg_password" type="password" @error="handleInputError"
                                            ref="password" id="password" name="password" label="Пароль" required />
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <CInput v-model="reg_password_repeated" type="password"
                                            @error="handleInputError" ref="password_repeated" id="password_repeated"
                                            name="password_repeated" label="Повторите пароль" required />
                                    </div>
                                </div>
                            </div>

                            <div class="policy-checkbox">
                                <CheckboxGroup name="oferta" type="checkbox" checkboxesClass="checkbox"
                                    :checkboxes="ofertaCheckboxes" maxSelected="1" requiredCount="1"
                                    @error="handleInputError" />
                                <div>Я
                                    ознакомился и принимаю условия <a href="/Оферта_Medmobil.pdf"
                                        target="_blank">Оферты</a> и <a href="/license.pdf" target="_blank">Политики
                                        конфиденциальности</a></div>
                            </div>

                            <div class="">
                                <label style="color:red;" v-html="errorHtml"></label>
                            </div>

                            <div class="d-flex justify-content-center">
                                <button id="send_app" type="submit" value="Отправить заявку"
                                    v-on:click="checkInputError"
                                    class="ui-button ui-button--xl ui-button--secondary">Отправить заявку</button>
                            </div>
                        </template>
                    </FormComponent>
                </div>
            </TabsComponent>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { mask } from 'vue-the-mask';
import popup from './ModalComponent.vue';
import tools from '@/assets/js/tools.js';
import TabsComponent from './TabsComponent.vue';
import CInput from './InputComponent.vue';
import CheckboxGroup from './CheckboxComponent.vue';
import FormComponent from './FormComponent.vue';

export default {
    name: 'CarriersPage',
    directives: { mask },
    components: {
        'PopupWindow': popup,
        TabsComponent,
        CheckboxGroup,
        CInput,
        FormComponent
    },
    data() {
        return {
            ofertaCheckboxes: [
                { id: 'oferta1', name: 'oferta', value: 'true', label: '', checked: false },
            ],
            pageTabs: [
                { id: 'offer', label: 'Наше предложение' },
                { id: 'user', label: 'Станьте участником' },
            ],
            formsStatus: [],
            activeTab: 'offer',
            errorHtml: '',
            modal: {
                header: 'Подтверждение',
                info: '',
                button: '',
                color: '#0ECCAA'
            },
            isVisiblePopup: false,
            reg_name: '',
            reg_secondname: '',
            reg_email: '',
            reg_organisation: '',
            reg_password: '',
            reg_password_repeated: '',
            inn: "",
            phone: "",
            tools: tools
        };
    },
    methods: {
        sendResponseCarriers() {
            var vm = this;
            var carrier_data = {
                firstname: vm.reg_name,
                secondname: vm.reg_secondname,
                email: vm.reg_email,
                phone: vm.phone,
                organisation: vm.reg_organisation,
                inn: vm.inn,
                password: vm.reg_password
            };
            var formData = JSON.stringify(carrier_data);
            $.ajax({
                type: "POST",
                url: global.BACKEND_URL + "/account/new_carrier",
                data: formData,
                success: function () {
                    vm.modal = {
                        header: 'Информация',
                        info: 'Благодарим за заявку! Вы получите права владельца услуги как только администратор одобрит Вашу заявку',
                        button: 'ОК',
                        color: '#0ECCAA'
                    },
                        vm.isVisiblePopup = true;
                },
                error: function () {
                    vm.errorHtml = "Пользователь с таким адресом электронной почты уже существует."
                },
                dataType: "text",
                contentType: "application/json"
            });
        },
        handleFormResponse(event) {
            const result = event.detail.result;
            const name = event.detail.formName;
            this.formsStatus[name] = !result
            return result
        },
        updateFormErrors(data) {
            this.formsStatus[data.formName] = !data.hasError
        },
        updateActiveTab(tab) {
            var vm = this;
            vm.activeTab = tab
        },
    }
}
</script>

<style lang="scss">
.policy-checkbox {
    display: inline-flex;
    align-items: center;

    a {
        color: var(--color-blue);
        text-decoration: dotted;
    }
}
</style>
